import classNames from "classnames/bind";
import React from "react";
import ReactDOM from "react-dom";
import { COMPARE_STORE_CONTEXT } from "./CompareStore";
import { Comparision } from "./Comparision";
import { useObservableState } from "./UseObservableState";
import "./FloatingCompareButton.css";

export const FloatingCompareButton = () => {
  const compareStore = React.useContext(COMPARE_STORE_CONTEXT);
  const comparePropertyLength = useObservableState(
    compareStore.comparePropertyLength$
  );

  window.setCompareProperty = setCompareGlobal;

  function setCompareGlobal(prop) {
    compareStore.addCompareProperty(prop)
  }

  return (
    <>
      <div
        className={classNames([
          { "d-none": !Boolean(comparePropertyLength) },
          "box-icon-comparision",
        ])}
      >
        <div className="wrap-noti-compare">
          <p className="number">{comparePropertyLength}</p>
          <i className="ic-npa ic-npa-icon-compare"></i>
        </div>
      </div>
      <Comparision />
    </>
  );
};

// ReactDOM.render(
//   <FloatingCompareButton />,
//   document.getElementById("react-app-floating-compare-button")
// );
